import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandler } from '../../../../shared/ErrorHandler';
import { UserService } from '../../../../shared/user.service';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-hospitalform',
  templateUrl: './hospitalform.component.html',
  styleUrls: ['./hospitalform.component.css']
})
export class HospitalformComponent implements OnInit {
title =  'Hospital Details';
data : any = {};
formInvalid : boolean = false;
d : any = {};
fileToUpload: File = null;

HO_Id : number;
mode : string;
ActiveDetailsList: any=[];
ActiveDetails: any=[];
ActiveDetail: any=[];
ActiveDetai: any=[];
Active: any=[];
ActiveDistrict: any=[];
photoImageUrl: any;
AS_Photo: string;
Activespili: any=[];
constructor(public service : UserService,private router: Router,private route: ActivatedRoute,  private errorHandler: ErrorHandler) { }

ngOnInit() {
  // this.GetAllPSADetailsForDropdown();
  // this.GetAllPSADisgnation();
  // this.GetAllQualification();
  this.GetState();
  this.GetsDistrict();
  this.GetAllPSADetailsForDropdown();
  this.route.params.subscribe(params => {      
    this.HO_Id = params['HO_Id'];  
    this.mode  =   params['mode'];   
      
      if(this.HO_Id > 0){
        this.getbyid(this.HO_Id)
      }    
      
  });

  if(this.mode=='view'){
    this.title = "View Hospital";
  }
  else if(this.mode=='edit'){
    this.title = "Edit Hospital";
  } 
 
}
SaveDistrict(Distict: NgForm){
      
  if(Distict.invalid)
  {
    this.formInvalid = true;
    swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
    return;
  }     

  else{                                     
          this.data = this.service.Posthosptal(Distict.value);    
          this.data.subscribe(
          (response) => {
            Distict.reset();
            Distict.resetForm();
            Distict.form.markAsPristine();
            Distict.form.markAsUntouched();        
            swal('Success!', 'Hospital Added Successfully .', 'success');
            this.router.navigate(['/home/hospital']) ;   
            document.getElementById('loader-spinner').style.display = "none";           
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });    
  
  
  } 
}
cancel(){
  this.d.district_name="";
}

UpdateDistrict(District: NgForm) {  
  this.data = this.service.updatehospital(District.value,this.HO_Id);
 this.data.subscribe(
   (response) => {
    District.reset();
    District.resetForm();
    District.form.markAsPristine();
    District.form.markAsUntouched();           
                 
     swal('Success!', 'Hospital updated Successfully .', 'success');
       
     this.router.navigate(['/home/hospital']) ;
     document.getElementById('loader-spinner').style.display = "none";           
   }, (error) => {
     document.getElementById('loader-spinner').style.display = "none";
     if (error.status == 401) {
       this.errorHandler.HandlerError(error);
     }
     else if (error.status == 400) {
      swal('Warning!', error.error.Message, 'warning');
     }
   });   
}

Cancel(){
//this.router.navigate(['/menu/master']) ; 
this.d.district_name='';
this.d.district_id='';
}
GetAllPSADetailsForDropdown(){



  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.service.Getallnetwork();
  this.data.subscribe(
    (response: any) => {
      this.ActiveDetailsList = response;
    document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      document.getElementById('loader-spinner').style.display = "none";
    });
}
// GetAllPSADisgnation(){
//   //alert('Inside');
  
  
//     document.getElementById('loader-spinner').style.display = "block";
//     this.data = this.service.GetallCategoryDropDown();
//     this.data.subscribe(
//       (response: any) => {
//         this.ActiveDetails = response;
//       document.getElementById('loader-spinner').style.display = "none";
//       }, (error) => {
//         document.getElementById('loader-spinner').style.display = "none";
//       });
//   }
//   GetAllQualification(){
//     //alert('Inside');
    
    
//       document.getElementById('loader-spinner').style.display = "block";
//       this.data = this.service.GetallCategoryDrop();
//       this.data.subscribe(
//         (response: any) => {
//           this.ActiveDetail = response;
//         document.getElementById('loader-spinner').style.display = "none";
//         }, (error) => {
//           document.getElementById('loader-spinner').style.display = "none";
//         });
//     }
    GetState(){
      //alert('Inside');
      
      
        document.getElementById('loader-spinner').style.display = "block";
        this.data = this.service.GetallCategory();
        this.data.subscribe(
          (response: any) => {
            this.Active = response;
          document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
          });
      }
      GetsDistrict(){
        //alert('Inside');
        
        
          document.getElementById('loader-spinner').style.display = "block";
          this.data = this.service.GetallCategorydrop();
          this.data.subscribe(
            (response: any) => {
              this.ActiveDistrict = response;
            document.getElementById('loader-spinner').style.display = "none";
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
            });
        }
        // Getsspi(){
        //   //alert('Inside');
          
          
        //     document.getElementById('loader-spinner').style.display = "block";
        //     this.data = this.service.GetCategory();
        //     this.data.subscribe(
        //       (response: any) => {
        //         this.Activespili = response;
        //       document.getElementById('loader-spinner').style.display = "none";
        //       }, (error) => {
        //         document.getElementById('loader-spinner').style.display = "none";
        //       });
        //   }
        FileInputPhoto(file: FileList) {
  
          //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
          let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|JPEG|JPG)$/;
          let s: any = file.item(0).size / 1024;
          let size: any = parseFloat(s).toFixed(2);
          let uploadedFilename = file.item(0).name;
          if (uploadedFilename.match(regex) && (size <= 5048)) {
            this.fileToUpload = file.item(0);
            var reader = new FileReader();
            reader.onload = (event: any) => {
               this.photoImageUrl = event.target.result;
            }
            reader.readAsDataURL(this.fileToUpload);
            const data = new FormData();
            data.append("UploadedImage", file.item(0));
            let x = this.service.uploadImagesFile(data);
            x.subscribe(
              (response) => {
                
      
              }, (error) => {
                let i: any = document.getElementById('AS_Photo');
                i.value = "";
                if (error.status == 400) {
                   this.AS_Photo = "assets/images/image-default.png";
                  swal('Warning!', error.error.Message, 'warning');
                }
              });
          }
          else {
            let i: any = document.getElementById('AS_Photo');
            i.value = "";
            if (!uploadedFilename.match(regex))
              swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
            else if (size > 2048)
              swal('Warning!', "Please upload image file less than 2mb", 'warning');
          }
        }
        
      
        getImagePDFUrl() {
          let imagename = null;
          try {
            imagename = document.getElementById('Image_path');
            return imagename.files[0].name;
          }
          catch (e) {
            return null;
          }
        }
        getbyid(HO_Id) {
          {
            
           // this.a.Image_path=this.photoImageUrl;
            document.getElementById('loader-spinner').style.display = "block";
            this.data = this.service.getbyhospital(HO_Id);
            this.data.subscribe(
              (response: any) => {
              this.d = response;
              this.photoImageUrl=this.d.HO_HospitalLogo
               
          
           document.getElementById('loader-spinner').style.display = "none";
              }, (error) => {
                document.getElementById('loader-spinner').style.display = "none";
              });
          }
      
        }
      
}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/hospital/hospitalform/hospitalform.component.ts